import FilterWidgetComponent from './filter-widget.component'

const FilterWidgetModule = angular.module('cdbl.filter-widget', [

])
  .component('cdblFilterWidget', FilterWidgetComponent)
  .name

export default FilterWidgetModule
